import { type PatientSurfaceFieldName } from '../../../contracts';

/**
 * Maps a patient-profile form field key to the canonical analytics field name
 * (schema known values). Only the field name is ever tracked, never the value
 * (PII). Form fields without a canonical equivalent (email, phone, free-text
 * context) pass through verbatim — schema enums are documented-not-enforced, so
 * extending the set needs no schema bump.
 */
const FIELD_NAME_MAP: Record<string, PatientSurfaceFieldName> = {
  birth_date: 'dob',
  first_name: 'name',
  last_name: 'name',
  gender: 'gender',
  pronouns: 'pronouns',
  allergies: 'allergies',
  current_medications: 'medications',
  past_medical_history: 'medical_history',
};

export const toAnalyticsFieldName = (formField: string): string =>
  FIELD_NAME_MAP[formField] ?? formField;
